import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PropertyAmenties from '../json-pages/PropertyAmenties';
import PropertyActivities from '../json-pages/PropertyActivities';
import PropertyContactInfo from '../json-pages/PropertyContactInfo';
import PropertyInfo from '../json-pages/PropertyInfo';
import PropertyAmentiesBook from '../json-pages/PropertyAmentiesBook';
import PropertyLocation from '../json-pages/PropertyLocation';
import RoomAmenties from '../json-pages/RoomAmenties';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/amenities`} component={PropertyAmenties} />
      <Route path={`${match.url}/activities`} component={PropertyActivities} />
      <Route
        path={`${match.url}/contact-info`}
        component={PropertyContactInfo}
      />
      <Route path={`${match.url}/information`} component={PropertyInfo} />
      <Route
        path={`${match.url}/amentity-book`}
        component={PropertyAmentiesBook}
      />
      <Route path={`${match.url}/location`} component={PropertyLocation} />
      <Route path={`${match.url}/room-amentity`} component={RoomAmenties} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
